import FileInput from "../../../../components/common/ui/Inputs/FileInput";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
// import ReactQuill, { Quill } from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import { homePageActions } from "../../../../_store/home.slice";
import { useEffect, useRef, useState } from "react";
import FroalaEditor from "react-froala-wysiwyg";
import { config } from "../../Editor_Config/Froalaconfig";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";

function BannerContent({ onFileSelect, errorMessage }) {
  const dispatch = useDispatch();
  const { data } = useSelector((x) => x?.home?.homePageContentResponse);
  const isFirstRender = useRef(true);
  // const [editorStates, setEditorStates] = useState({
  //   bannerDescription: "",
  // });

  // const Size = Quill.import("attributors/style/size");
  // var Font = Quill.import("formats/font");
  // Quill.register(Size, true);
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  const homePageData = { ...data };

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  // Font.whitelist = [
  //   "arial",
  //   "courier-new",
  //   "georgia",
  //   "tahoma",
  //   "times-new-roman",
  //   "verdana",
  //   "impact",
  //   "wingdings",
  // ];

  // Size.whitelist = [
  //   "8pt",
  //   "10pt",
  //   "12pt",
  //   "14pt",
  //   "18pt",
  //   "24pt",
  //   "36pt",
  //   "48px",
  // ];

  // const CustomStyles = `
  // .ql-picker.ql-font .ql-picker-label::before,
  // .ql-picker.ql-font .ql-picker-item::before {
  //     font-family: initial !important;  /* Reset to default font */
  //     content: attr(data-value) !important;  /* Show font name */
  //     text-transform: capitalize !important;  /* Capitalize first letter */
  //     font-size: 16px !important;  /* Increase font size */
  // }

  //   .ql-picker.ql-font { width: 160px !important; }

  //     .ql-picker.ql-size .ql-picker-label::before,
  //     .ql-picker.ql-size .ql-picker-item::before {
  //         content: attr(data-value) !important;
  //         text-transform: none !important;
  //     }
  //         .ql-font-arial { font-family: Arial, sans-serif; }
  //         .ql-font-courier-new { font-family: Courier-New, monospace; }
  //         .ql-font-georgia { font-family: Georgia, serif; }
  //         .ql-font-tahoma { font-family: Tahoma, sans-serif; }
  //         .ql-font-times-new-roman { font-family: Times-New-Roman, serif; }
  //         .ql-font-verdana { font-family: Verdana, sans-serif; }
  //         .ql-font-impact { font-family: Impact, sans-serif; }
  //         .ql-font-wingdings { font-family: Wingdings; }

  //          /* Hide only the preview inside the tooltip */
  //         .ql-tooltip .ql-preview {
  //             max-width: 7px !important;
  //             height: 0px !important;
  //             overflow: hidden !important;
  //             white-space: nowrap !important;
  //             display: inline-block !important;
  //             visibility: hidden; /* Hides text but keeps the element */
  //         }
  //         .ql-snow .ql-tooltip::before {
  //             content: none !important; /* Removes the "Visit URL:" text */
  //         }
  //       .ql-snow .ql-tooltip a.ql-action::after {
  //           border-right: 1px solid #ccc;
  //           content: 'Edit';
  //           margin-left: 7px;
  //           padding-right: 8px;
  //       }
  // `;

  // const modules = {
  //   toolbar: [
  //     [{ font: Font.whitelist }],
  //     [{ size: Size.whitelist }],
  //     ["bold", "italic", "underline", "strike", "blockquote"],
  //     [{ list: "ordered" }, { list: "bullet" }],
  //     [{ script: "sub" }, { script: "super" }],
  //     [{ indent: "-1" }, { indent: "+1" }],
  //     [{ direction: "rtl" }],
  //     [{ color: [] }, { background: [] }],
  //     [{ align: [] }],
  //     ["link"],
  //     ["clean"],
  //   ],
  //   clipboard: {
  //     matchVisual: false,
  //   },
  // };

  useEffect(() => {
    const descValue = { ...homePageData };
    descValue.bannerDescription = homePageData?.bannerDescription;
    // setEditorStates(descValue);
    dispatch(homePageActions?.updateHomePageResponse(descValue));
  }, [homePageData?.sectionOneDescription]);

  const handleEditorChanges = (content, name) => {
    // setActiveEditor(name);
    if (isFirstRender.current) return;
    const cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");
    // setEditorStates((prev) => ({
    //   ...prev,
    //   [name]: cleanedContent,
    // }));

    // Do not dispatch if unchanged
    if (homePageData[name] === cleanedContent || !homePageData) return;

    const payload = { ...homePageData };
    payload[name] = cleanedContent;

    dispatch(homePageActions?.updateHomePageResponse(payload));
  };

  const allowedMimeTypes = ["image/jpeg", "image/png", "image/webp"];
  const handleChange = (e) => {
    const { name, value, type } = e?.target;
    if (value.startsWith(" ")) return;
    if (type === "file") {
      let file = e.target.files[0];
      if (!file) return;

      if (allowedMimeTypes.includes(file.type)) {
        homePageData["bannerImageToShow"] = file;
        // pageData.fileCheck = { name: file.name, type: file.type || "" };
      } else {
        showToastNotification("Unsupported Media Type", "error");
        homePageData["bannerImageToShow"] = undefined;
        // pageData.fileCheck = undefined;
        e.target.value = ""; // reset input field
        file = "";
        return;
      }

      const formData = new FormData();
      formData.append("image", file);
      onFileSelect(file);
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        homePageData["bannerImageToShow"] = imageUrl;
      }
      dispatch(homePageActions?.updateHomePageResponse(homePageData));
      return;
    }
    homePageData[name] = value;
    dispatch(homePageActions?.updateHomePageResponse(homePageData));
  };

  return (
    <>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
          Banner
        </h1>
        <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                name="bannerTitle"
                label="Title"
                placeholder="Title"
                value={homePageData?.bannerTitle}
                maxLength={21}
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
                required
              />
            </div>
            <div className="col-md-4">
              <TextInput
                name="bannerButtonLabel"
                label="Button Label"
                placeholder="Button Text"
                maxLength={36}
                value={homePageData?.bannerButtonLabel}
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
                required
              />
            </div>
            <div className="col-md-4">
              <TextInput
                name="bannerButtonUrl"
                label="Button URL"
                placeholder="Button URL"
                value={homePageData?.bannerButtonUrl}
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
                required
              />
            </div>

            <div className="col-md-4">
              <FileInput
                name="bannerImageOne"
                label="Banner Image"
                // value={bannerImage}
                imageURL={
                  homePageData?.bannerImageToShow === undefined
                    ? ImageURL + homePageData?.bannerImageOne
                    : homePageData?.bannerImageToShow
                }
                handleFileChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
                required
              />
            </div>
            <div className="col-md-8">
              <label
                className={`form-label col-form-label  w-100 fs-5 form-label-custom-visible `}
              >
                Description {<span className="text-danger">*</span>}
              </label>

              <div className="quill-container" id="toolbar">
                {/* <style>{CustomStyles}</style> */}
                <div>
                  {/* <ReactQuill
                    name="bannerDescription"
                    theme="snow"
                    value={editorStates.bannerDescription || ""}
                    onChange={(e) => {
                      handleEditorChanges(e, "bannerDescription");
                    }}
                    modules={modules}
                    className={`editor-block ${
                      errorMessage["bannerDescription"] ? "input-error" : ""
                    }`}
                  /> */}
                  <FroalaEditor
                    tag="textarea"
                    name="bannerDescription"
                    config={config} // your toolbar, plugins, etc.
                    model={homePageData?.bannerDescription || ""} // ✅ value binding
                    onModelChange={(e) => {
                      // ✅ onChange equivalent
                      handleEditorChanges(e, "bannerDescription");
                    }}
                    className={`editor-block ${errorMessage?.["bannerDescription"] ? "input-error" : ""
                      }`}
                  />
                </div>
              </div>
              {errorMessage?.bannerDescription && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.bannerDescription}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BannerContent;
